var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessagesSmallIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08889 13.6889V6.11111H2.44444C1.1 6.11111 0 7.21111 0 8.55556V15.8889C0 17.2333 1.1 18.3333 2.44444 18.3333H3.66667V22L7.33333 18.3333H13.4444C14.7889 18.3333 15.8889 17.2333 15.8889 15.8889V13.6644C15.8086 13.6817 15.7266 13.6903 15.6444 13.6901H7.08889V13.6889ZM22 0H11C9.65556 0 8.55556 1.1 8.55556 2.44444V12.2222H17.1111L20.7778 15.8889V12.2222H22C23.3444 12.2222 24.4444 11.1234 24.4444 9.77778V2.44444C24.4444 1.1 23.3444 0 22 0Z",
    fill: "#868A95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesSmallIcon);
export default __webpack_public_path__ + "static/media/messages-small-icon.eca0fec98caef64d23a2481d7aa3e708.svg";
export { ForwardRef as ReactComponent };